<script>
import moment from "moment";
import n2c from "@/common/numberToChinese";
import { MapGender, MapGameLabel } from "@/common/util";
import cloneDeep from "lodash/cloneDeep";
import sortBy from "lodash/sortBy";
const mapUserInfoLabel = {
  RIGHT: "RIGHT_EYE",
  LEFT: "LEFT_EYE",
  BINOCULAR_SIMULTANEOUS: "NO_COVER",
  SEPARATION: "RIGHT_EYE"
};
export default {
  data() {
    const stationId = this.$route.params.stationId;
    const patientId = this.$route.params.patientId;
    const gameLabel = this.$route.params.gameType;
    const trainingId = this.$route.params.trainingId;
    const initialLevel = this.$route.params.level;
    const trainingEyeType = this.$route.params.trainEye;
    const userInfoLabel = this.$route.params.userInfoLabel;
    const stimulusLevel = this.$route.params.stimulusLevel;
    const gameId = this.$route.params.gameId;
    const gameType = MapGameLabel(gameLabel);
    return {
      stationId,
      patientId,
      gameId,
      initialLevel,
      trainingId,
      isShowStimulusLevel: false,
      typeSource: [
        {
          name: "精细刺激训练",
          type: "FINE_STIMULATION_TRAINING"
        },
        {
          name: "视觉技巧训练",
          type: "VISUAL_SKILL_TRAINING"
        },
        {
          name: "同时视",
          type: "SAME_TIME_BINOCULAR_VISION_TRAINING"
        },
        {
          name: "融合视",
          type: "FUSION_VISION_BINOCULAR_VISION_TRAINING"
        },
        {
          name: "立体视",
          type: "STEREOSCOPIC_BINOCULAR_VISION_TRAINING"
        },
        {
          name: "Gabor训练",
          type: "GABOR_TRAINING"
        },
        {
          name: "对比敏感度训练",
          type: "CONTRAST_SENSITIVITY_TRAINING"
        },
        {
          name: "信息提取训练",
          type: "INFORMATION_EXTRACTION_TRAINING"
        }
      ],
      type: gameType,
      gameLabel,
      games: [],
      gameLevel: initialLevel,
      gameMaxLevel: 5,
      precisionConfig: {
        unit: "像素(px)",
        mix: 1,
        max: 100
      },
      colors: [
        "#86C4EB",
        "#C4BCF0",
        "#86D49F",
        "#F2D895",
        "#F59598",
        "#88EBE4",
        "#EE9BCD",
        "#FFC79F"
      ],
      bgConfig: null,
      allModeList: [],
      trainingEyeType: trainingEyeType || undefined,
      userInfoLabel,
      modelLevels: [
        {
          name: "刺激等级1",
          type: "1"
        },
        {
          name: "刺激等级2",
          type: "2"
        },
        {
          name: "刺激等级3",
          type: "3"
        },
        {
          name: "刺激等级4",
          type: "4"
        },
        {
          name: "刺激等级5",
          type: "5"
        },
        {
          name: "刺激等级6",
          type: "6"
        },
        {
          name: "刺激等级7",
          type: "7"
        },
        {
          name: "刺激等级8",
          type: "8"
        },
        {
          name: "刺激等级9",
          type: "9"
        },
        {
          name: "刺激等级10",
          type: "10"
        }
      ],
      trainStimulusLevel: stimulusLevel == "null" ? undefined : stimulusLevel
    };
  },
  computed: {
    isRedAndBlue() {
      if (
        this.type === "SAME_TIME_BINOCULAR_VISION_TRAINING" ||
        this.type === "FUSION_VISION_BINOCULAR_VISION_TRAINING" ||
        this.type === "STEREOSCOPIC_BINOCULAR_VISION_TRAINING"
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    type() {
      this.loadData();
    },
    gameId(gameId) {
      if (gameId) {
        this.getBgs();
      }
    }
  },
  created() {
    this.loadData();
    this.getBgs();
  },
  methods: {
    n2c,
    async loadData() {
      const result = await this.$http.getGameList(this.type);
      this.games = result.data ? result.data.content : [];
      if (this.games.length) {
        let Games = this.games.filter(o => o.id === this.gameId);
        let activeGame = this.games[0];
        let activeGameLevel = 1;
        if (Games.length > 0) {
          activeGame = Games[0];
          activeGameLevel = this.initialLevel;
        }
        const gameLevel = activeGameLevel;
        this.gameId = activeGame.id;
        let gameMaxLevel = [];
        for (let i = 1; i <= activeGame.totalLevel; i++) {
          gameMaxLevel.push({
            name: `关卡${i}`,
            key: i
          });
        }
        this.gameMaxLevel = gameMaxLevel;
        this.gameLevel = gameLevel;
        // sessionStorage.setItem("gameType", this.type);
        if (this.isRedAndBlue) {
          this.trainingEyeType = "WITH_GLASSES";
        } else {
          if (this.$route.params.trainEye === "WITH_GLASSES") {
            this.trainingEyeType =
              mapUserInfoLabel[this.userInfoLabel] || "RIGHT_EYE";
          } else {
            this.trainingEyeType = this.$route.params.trainEye;
          }
        }
      }
    },
    async getBgs() {
      let result = {};
      let defaultResult = {};
      let allModeList = [];
      if (this.gameId) {
        defaultResult = await this.$http.getBGConfigDefault(this.gameId);
        if (this.gameLevel > -1) {
          result = await this.$http.getBGConfig(this.gameId, this.gameLevel);
          if (result && result.data) {
            this.isShowStimulusLevel = !!result.data.isShowStimulusLevel;
          }
        }
      }

      if (defaultResult && defaultResult.data) {
        if (result && result.data && result.data.resource) {
          let gameMaxLevel = [];
          for (let i = 1; i <= result.data.game.totalLevel; i++) {
            gameMaxLevel.push({
              name: `关卡${i}`,
              key: i
            });
          }
          this.gameMaxLevel = gameMaxLevel;
          if (
            result.data.resource.centralFixation &&
            result.data.resource.centralFixation.length > 0
          ) {
            let tempBgs = result.data.resource.centralFixation;
            for (let index in result.data.resource.centralFixation) {
              for (let name in result.data.resource.centralFixation[index]
                .config) {
                let temp =
                  result.data.resource.centralFixation[index].config[name];
                if (temp.storeType === "OSS") {
                  let values = temp.imageList.map(o => o.split("?")[0]);
                  tempBgs[index].config[name].imageList = values;
                }
              }
            }
            this.centralFixationConfig = result.data.resource.centralFixation;
            let sizes = this.centralFixationConfig.map(
              item => item.config.duration.value
            );
            let total = sizes.reduce((item1, item2) => item1 + item2);
            let bgRatioDataCenter = [];
            let duration = 0;
            this.centralFixationConfig.forEach((item, index) => {
              let size = item.config.duration.value;
              bgRatioDataCenter.push({
                name: item.name,
                size: size + item.config.duration.unit,
                ratio: Number((size / total) * 100).toFixed(2) + "%",
                color: this.colors[index % 8]
              });
              if (item.config && item.config.duration) {
                duration += parseInt(item.config.duration.value);
              }
            });
            allModeList.push({
              name: "中心刺激背景",
              value: this.centralFixationConfig,
              bgRatio: bgRatioDataCenter,
              duration
            });
          }
          if (
            result.data.resource.ecCentralFixation &&
            result.data.resource.ecCentralFixation.length > 0
          ) {
            let tempBgs = result.data.resource.ecCentralFixation;
            for (let index in result.data.resource.ecCentralFixation) {
              for (let name in result.data.resource.ecCentralFixation[index]
                .config) {
                let temp =
                  result.data.resource.ecCentralFixation[index].config[name];
                if (temp.storeType === "OSS") {
                  let values = temp.imageList.map(o => o.split("?")[0]);
                  tempBgs[index].config[name].imageList = values;
                }
              }
            }
            this.ecCentralFixationConfig =
              result.data.resource.ecCentralFixation;
            let sizes = this.ecCentralFixationConfig.map(
              item => item.config.duration.value
            );
            let total = sizes.reduce((item1, item2) => item1 + item2);
            let bgRatioDataEcCenter = [];
            let duration = 0;
            this.ecCentralFixationConfig.forEach((item, index) => {
              let size = item.config.duration.value;
              bgRatioDataEcCenter.push({
                name: item.name,
                size: size + item.config.duration.unit,
                ratio: Number((size / total) * 100).toFixed(2) + "%",
                color: this.colors[index % 8]
              });
              if (item.config && item.config.duration) {
                duration += parseInt(item.config.duration.value);
              }
            });
            // this.allModeList["旁中心刺激背景"] = this.ecCentralFixationConfig;
            allModeList.push({
              name: "旁中心刺激背景",
              value: this.ecCentralFixationConfig,
              bgRatio: bgRatioDataEcCenter,
              duration
            });
          }
          if (
            result.data.resource.nystagmus &&
            result.data.resource.nystagmus.length > 0
          ) {
            let tempBgs = result.data.resource.nystagmus;
            for (let index in result.data.resource.nystagmus) {
              for (let name in result.data.resource.nystagmus[index].config) {
                let temp = result.data.resource.nystagmus[index].config[name];
                if (temp.storeType === "OSS") {
                  let values = temp.imageList.map(o => o.split("?")[0]);
                  tempBgs[index].config[name].imageList = values;
                }
              }
            }
            this.nystagmus = result.data.resource.nystagmus;
            let sizes = this.nystagmus.map(item => item.config.duration.value);
            let total = sizes.reduce((item1, item2) => item1 + item2);
            let bgRatioDatanyNystagmus = [];
            let duration = 0;
            this.nystagmus.forEach((item, index) => {
              let size = item.config.duration.value;
              bgRatioDatanyNystagmus.push({
                name: item.name,
                size: size + item.config.duration.unit,
                ratio: Number((size / total) * 100).toFixed(2) + "%",
                color: this.colors[index % 8]
              });
              if (item.config && item.config.duration) {
                duration += parseInt(item.config.duration.value);
              }
            });
            // this.allModeList["眼球震颤刺激背景"] = this.nystagmus;
            allModeList.push({
              name: "眼球震颤心刺激背景",
              value: this.nystagmus,
              bgRatio: bgRatioDatanyNystagmus,
              duration
            });
          }
          if (result.data.resource.config) {
            let tempBgConfig = cloneDeep(result.data.resource.config);
            for (let name in result.data.resource.config) {
              let item = cloneDeep(result.data.resource.config[name]);
              if (
                item.type === "number" &&
                item.templateName === "TEXT_GROUP_INPUT"
              ) {
                let values = item.value.map(o => parseFloat(o));
                tempBgConfig[name].value = values;
              } else if (item.storeType === "OSS") {
                if (item.templateName === "IMAGE_INPUT") {
                  let values = item.value.split("?")[0];
                  tempBgConfig[name].value = values;
                } else if (item.templateName === "IMAGE_GROUP_INPUT") {
                  let values = item.value.map(o => o.split("?")[0]);
                  tempBgConfig[name].value = values;
                }
              } else if (item.templateName === "SLIDER_RATIO_INPUT") {
                const value = result.data.resource.config[name].value;
                let values = Math.floor(value * 100);
                // console.log("values:", values);
                tempBgConfig[name].value = values;
              }
            }
            this.bgConfig = tempBgConfig;
            this.allModeList = allModeList;
          } else {
            this.bgConfig = null;
          }
        } else {
          this.bgConfig = null;
          this.allModeList = allModeList;
        }
        // this.staticCongig = JSON.parse(JSON.stringify(this.bgConfig));
        // this.defaultBgs = defaultResult.data.modeList;
      }
    },
    onSelectGame(gameId) {
      if (gameId) {
        this.gameLevel = 1;
      }
    },
    onSelectLevel(level) {
      if (level) {
        this.getBgs();
      }
    },
    async onSubmit() {
      const updateData = {
        patientId: this.patientId,
        trainingId: this.trainingId
      };
      if (this.gameId !== this.$route.params.gameId) {
        updateData.gameId = this.gameId;
        updateData.level = this.gameLevel;
        updateData.trainingEyeType = this.trainingEyeType;
      } else {
        if (this.initialLevel !== this.gameLevel) {
          updateData.level = this.gameLevel;
        }
        if (this.trainingEyeType !== this.$route.params.trainEye) {
          updateData.trainingEyeType = this.trainingEyeType;
        }
      }

      if (this.trainStimulusLevel) {
        updateData.stimulusLevel = this.trainStimulusLevel;
      }
      // console.log("--->>>>", updateData);
      const result = await this.$http.doctorConfigPatientGameLevel(updateData);
      if (result === "success") {
        this.$message.success("保存成功！");
      }
    }
  }
};
</script>
<template>
  <div class="trainDetailSetLevelIndex">
    <el-breadcrumb class="headerLinkView" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>您的位置：</el-breadcrumb-item>
      <el-breadcrumb-item :replace="true" :to="{ path: '/index/patientManagement' }">患者管理</el-breadcrumb-item>
      <el-breadcrumb-item
        :replace="true"
        :to="{ path: `/index/patientManagement/patientManagementDetail/${patientId}/${stationId}` }"
      >患者详情</el-breadcrumb-item>
      <el-breadcrumb-item>关卡配置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card cardStyle" shadow="never">
      <div class="configGroup typeGroup">
        <p>训练类别：</p>
        <div>
          <div v-for="typeInfo in typeSource" :key="typeInfo.type + typeInfo.name">
            <el-radio v-model="type" :label="typeInfo.type">{{typeInfo.name}}</el-radio>
          </div>
        </div>
      </div>
      <div class="configGroup gameSelGroup">
        <p>选择游戏：</p>
        <div>
          <el-select size="mini" v-model="gameId" @change="onSelectGame">
            <el-option
              v-for="game in games"
              :key="game.id + game.name"
              :label="game.name"
              :value="game.id"
            />
          </el-select>
        </div>
        <div v-if="gameMaxLevel.length > 0">
          <p>选择关卡：</p>
          <div>
            <el-select size="mini" v-model="gameLevel" @change="onSelectLevel">
              <el-option
                v-for="item in gameMaxLevel"
                :key="item.key + item.name"
                :label="item.name"
                :value="item.key"
              />
            </el-select>
          </div>
        </div>
        <div>
          <p>训练眼别：</p>
          <div>
            <el-select size="mini" v-model="trainingEyeType">
              <el-option v-if="!isRedAndBlue" label="左眼" value="LEFT_EYE" />
              <el-option v-if="!isRedAndBlue" label="右眼" value="RIGHT_EYE" />
              <el-option v-if="!isRedAndBlue" label="双眼同时" value="NO_COVER" />
              <el-option v-if="isRedAndBlue" label="红蓝眼镜" value="WITH_GLASSES" />
              <!-- <el-option label="其他" value="UNKNOWN" /> -->
            </el-select>
          </div>
        </div>
        <div>
          <el-button type="primary" size="small" @click="onSubmit" class="submitButton">提交</el-button>
        </div>
      </div>
      <div class="configGroup gameSelGroup" v-if="isShowStimulusLevel">
        <p>刺激等级：</p>
        <div>
          <el-select size="mini" v-model="trainStimulusLevel" class="selectInputStyle">
            <el-option
              v-for="(model, index) in modelLevels"
              :key="index + '_modelLevel'"
              :label="model.name"
              :value="model.type"
            />
          </el-select>
        </div>
      </div>
    </el-card>
    <el-card shadow="never" class="configCard">
      <div slot="header" class="clearfix">
        <span>关卡{{n2c(gameLevel)}}配置</span>
      </div>
      <div v-if="!bgConfig && allModeList.length === 0" class="no-defult-config">暂无配置</div>
      <div>
        <el-row v-if="bgConfig">
          <el-col :span="3" class="tableLayOut">
            <p class="tableLabel">游戏设置</p>
          </el-col>
          <el-col :span="21" class="tableLayOut">
            <div class="numberGroup">
              <div v-for="(item, index) in bgConfig" :key="index + 'bgConfig'" class="numberGroup">
                <p>{{item.name}}: {{item.value}} {{`${item.unit ? item.unit : ''}`}}</p>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row v-for="(mode,index) in allModeList" :key="mode.name + index">
          <el-col :span="3" class="tableLayOut">
            <p class="tableLabel">{{mode.name}}</p>
          </el-col>
          <el-col :span="21" class="tableLayOut">
            <el-row>
              <el-col
                v-if="mode.value && mode.value.length > 0"
                :span="24"
                class="tableLayOut tableLabel"
              >
                <div id="spectrum" class="spectrum">
                  <div
                    v-for="(item, index) in mode.bgRatio"
                    :key="index + 'bgRatio' + item "
                    class="spectrum-item"
                    :style="{width: item.ratio, backgroundColor: item.color}"
                    :title="item.name"
                  >
                    <span>{{item.name}}</span>
                    <span style="margin-left: 6px;">{{item.size}}</span>
                  </div>
                </div>
                <div class="alert">
                  <i class="el-icon-info"></i>
                  <p>
                    背景由
                    <span>{{mode.value.length}}</span>种刺激模式组成，这几种刺激模式依次出现并构成一个循环，当前循环总时间为
                    <span>{{mode.duration}}</span>秒
                  </p>
                </div>
              </el-col>
              <el-col :span="24" class="tableLayOut tableLabel">
                <el-row
                  class="tableLayOut mode"
                  v-for="(bgInfo, indexOfBgs) in mode.value"
                  :key="bgInfo.name + indexOfBgs"
                >
                  <el-col :span="3" class="tableLayOut">
                    <div class="tableLabel">{{`刺激模式${n2c(indexOfBgs + 1)}`}}</div>
                  </el-col>
                  <el-col :span="21" class="tableLayOut tableLabel">
                    <div class="bgOperation">
                      <p>{{bgInfo.name}}</p>
                    </div>

                    <div
                      v-for="(config, indexOfConfig) in bgInfo.config"
                      :key="indexOfConfig + bgInfo.name"
                    >
                      <div
                        v-if="config.templateName && config.templateName === 'COLOR_GROUP_INPUT'"
                      >
                        <div
                          v-for="(item, index2) in config.colorList"
                          :key="index2 + 'colorList' + bgInfo.name"
                          class="bg-input-suffix"
                        >
                          <span class="titleOfItem">背景颜色组{{n2c(index2 +1)}}:</span>
                          <span
                            v-for="(obj, index3) in item"
                            :key="index3 + item[index3] + + 'colorList' + bgInfo.name"
                            class="bg-input color-group"
                          >
                            <span>{{item[index3]}}</span>
                            <i
                              slot="suffix"
                              class="el-input__icon el-icon-picture"
                              :style="{'color': item[index3], 'background-color': item[index3],'border': '1px #666666 solid'}"
                            ></i>
                          </span>
                        </div>
                      </div>
                      <div
                        v-else-if="config.templateName && config.templateName === 'IMAGE_GROUP_INPUT'"
                      >
                        <div
                          v-for="(obj, index2) in config.imageList"
                          :key="index2 + config.imageList[index2] + 'imageList' + bgInfo.name"
                          class="bg-input-suffix"
                        >
                          <span class="titleOfItem">背景图片{{n2c(index2+1)}}:</span>
                          {{config.imageList[index2]}}
                        </div>
                      </div>
                      <div
                        v-else-if="config.templateName && config.templateName === 'SWITCH_INPUT'"
                        class="bg-input-suffix"
                      >
                        <span class="titleOfItem">{{config.name}}:</span>
                        {{`${config.isClockWise ? '顺时针' : '逆时针'}`}}
                      </div>
                      <div v-else>
                        <span class="bg-input-suffix">
                          <span class="titleOfItem">{{config.name}}:</span>
                          {{config.value}} {{config.unit}}
                        </span>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.trainDetailSetLevelIndex {
  .cardStyle {
    margin: 0 1%;
    border: 0px;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #00c1de;
    background-color: #fff;
  }

  .el-radio__inner::after {
    background-color: #00c1de;
  }

  .el-radio__input.is-checked + .el-radio__label {
    color: #00c1de;
  }
  .submitButton {
    border-color: #00c1de;
    background-color: #00c1de;
  }
  .typeGroup {
    > div {
      display: flex;
      flex-wrap: wrap;
      width: 90%;

      > div {
        width: 157px;
        margin-bottom: 12px;
      }
    }
  }

  .numberGroup {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    > p {
      padding: 0 20px;
      margin: 10px;
      display: flex;
      align-items: center;

      > div {
        width: 100px;
        // height: ;
        margin: 0 10px;
      }
    }
  }
  .configGroup {
    display: flex;
    width: 95%;

    > p {
      // width: 116px;
      flex-shrink: 0;
      margin-right: 16px;
      // text-align: right;
    }

    > div {
      color: #5d5d5d;
      margin-right: 81px;

      .operationBtn {
        align-items: center;
        display: flex;
        margin-left: 20px;
        color: #3ca8f5;
        cursor: pointer;

        > i {
          margin-right: 10px;
          font-size: 16px;
          font-weight: 500;
        }
      }
    }
  }
  .gameSelGroup {
    margin-top: 17px;
    line-height: 32px;
    margin-bottom: 14px;

    > div {
      display: flex;
    }
  }
  .configCard {
    width: 95%;
    margin: auto;

    .el-card__header {
      background: #f7f7f7;
    }

    .el-card__body {
      padding: 0;
    }

    .el-row {
      border-top: 1px solid #f2f4f6;
      border-left: 1px solid #f2f4f6;
      border-right: 1px solid #f2f4f6;

      .tableLabel {
        padding: 20px 10px;
      }

      .tableLayOut {
        border-top: 1px solid #f2f4f6;
        border-left: 1px solid #f2f4f6;
        border-right: 1px solid #f2f4f6;
      }
    }
  }
  .spectrum {
    display: flex;
    width: 100%;
    height: 20px;
    line-height: 20px;
    margin-top: 6px;
    color: #fff;
    font-size: 12px;

    .spectrum-item {
      box-sizing: border-box;
      padding: 0 6px;
      // margin-right: 1px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;

      &:last-child {
        margin-right: 0;
      }
    }
  }
  .alert {
    height: 42px;
    background: rgba(249, 251, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(237, 240, 245, 1);
    display: flex;
    align-items: center;
    margin-top: 10px;

    > i {
      color: #00adc7;
      margin-right: 8px;
      margin-left: 29px;
    }

    > p > span {
      color: #00adc7;
    }
  }
  .bgOperation {
    height: 32px;
    display: flex;
    align-items: center;
    margin-bottom: 23px;
    color: #7f7f7f;
  }
  .bg-input-suffix {
    font-size: 14px;
    color: #7f7f7f;
    line-height: 32px;
    margin-left: 20px;
  }
  .color-group {
    display: inline-block;
    width: 120px;
    margin-right: 20px;
    span {
      display: inline-block;
      width: 60px;
    }
    i {
      line-height: 25px;
      height: 25px;
    }
  }
  .titleOfItem {
    width: 100px;
    display: inline-block;
  }
  .no-defult-config {
    width: 100%;
    height: 300px;
    padding-top: 15%;
    text-align: center;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.25);
    line-height: 24px;
  }
  .headerLinkView {
    padding-top: 10px;
    padding-left: 10px;
    .el-breadcrumb__inner.is-link,
    .el-breadcrumb__inner a {
      color: #00c1de;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/patientManagement/unplayTrainSet.vue